import BrowserStorage from "../services/StorageService/BrowserStorageService";
import { BASE_URL } from '../services/config';

const axios = require('axios');
const axiosApiInstance = axios.create({ timeout: 60 * 60 * 1000 });

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
    async config => {
        const token = JSON.parse(BrowserStorage.getItem('authToken'));
        const refreshToken = JSON.parse(BrowserStorage.getItem('refreshToken'));
        config.headers = {
            'x-token': `${token}`,
            'x-refresh-token': `${refreshToken}`,
            'Accept': 'application/json',
            'Content-Type': config.headers['Content-Type'] ? config.headers['Content-Type'] : 'application/json',
            'script-transport-security': 'max-age=31536000; includeSubDomains;',
            'x-frame-options': 'SAMEORIGIN',
            'x-xss-protection': '1; mode=block',
            'x-content-type-options': 'nosniff'
        };
        return config;
    },
    error => {
        Promise.reject(error);
    });
/*
// Response interceptor for API calls
axiosApiInstance.interceptors.response.use((response) => {
return response;
}, async function (error) {
const originalRequest = error.config;
if (error.response?.status === 403 && !originalRequest._retry) {
    originalRequest._retry = true;
    // const access_token = await refreshAccessToken();
    // axios.defaults.headers.common['x-token'] = access_token;
    // return axiosApiInstance(originalRequest);

    // to-do - will be uncommented the lines above after adding refreshAccessToken service
    return Promise.reject(error);
}
return Promise.reject(error);
});
*/
axiosApiInstance.interceptors.response.use(
    response => response,
    async error => {
        if (error.code === 'ECONNABORTED') {
            return Promise.reject({ response: { data: { status: false, message: 'GENERAL.TIME-OUT' } } })
        }
        const base_url = await BASE_URL;
        const originalRequest = error.config;
        // Prevent infinite loops
        if (error.response.status === 401 && (originalRequest.url === base_url + `/auth/token` ||
            (error.response.data && error.response.data.status === false && error.response.data.message === 'USER-DOES-NOT-EXISTS'))) {
            window.location.href = '/login?to=' + window.location.pathname;
            return Promise.reject(error);
        }
        // if(error.response.status === 404){
        //     window.location.href= '/404'
        //     return Promise.reject(error);
        // }
        if ((error.response.data.message === "TOKEN-HAS-EXPIRED" || error.response.data.message === "TOKEN-IS-INVALID") &&
            (error.response.status === 401 || error.response.status === 403)) {
            //(error.response.statusText === "Unauthorized" || error.response.statusText === 'Forbidden')) {
            const refreshToken = localStorage.getItem('refreshToken');

            if (refreshToken) {
                const tokenParts = JSON.parse(atob(refreshToken.split('.')[1]));
                // exp date in token is expressed in seconds, while now() returns milliseconds:
                const now = Math.ceil(Date.now() / 1000);
                if (tokenParts.exp > now) {
                    return axiosApiInstance
                        .post(base_url + `/auth/refresh-token`, { refreshToken: JSON.parse(refreshToken) })
                        .then((response) => {
                            const authToken = JSON.stringify(response.data.payload.token);
                            const refreshTokenI = JSON.stringify(response.data.payload.refreshToken);

                            localStorage.setItem('authToken', authToken);
                            localStorage.setItem('refreshToken', refreshTokenI);

                            axiosApiInstance.defaults.headers['x-token'] = authToken;
                            axiosApiInstance.defaults.headers['x-refresh-token'] = refreshTokenI;
                            originalRequest.headers['x-token'] = authToken;
                            originalRequest.headers['x-refresh-token'] = refreshTokenI;

                            return axiosApiInstance(originalRequest);
                        })
                        .catch(err => {
                            console.log(err)
                        });
                } else {
                    window.location.href = '/login?to=' + window.location.pathname;
                    error.response = {
                        message: 'REDIRECT-LOGIN',
                        status: false
                    }
                    return Promise.reject(error);
                }
            } else {
                console.log("Refresh token not available.")
                // window.location.href = '/login';
            }
        }
        // specific error handling done elsewhere
        return Promise.reject(error);
    }
);

export default axiosApiInstance;
